export default {
  listAriaLabelAddition: "children",
  detailsShown: ", selected"
};